import { render } from "./OverView.vue?vue&type=template&id=5a9b5a34&scoped=true&ts=true"
import script from "./OverView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverView.vue?vue&type=script&setup=true&lang=ts"

import "./OverView.vue?vue&type=style&index=0&id=5a9b5a34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9b5a34"],['__file',"src/pages/home/components/OverView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a9b5a34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a9b5a34', __exports__)) {
    api.reload('5a9b5a34', __exports__)
  }
  
  module.hot.accept("./OverView.vue?vue&type=template&id=5a9b5a34&scoped=true&ts=true", () => {
    api.rerender('5a9b5a34', render)
  })

}


export default __exports__